import React from "react";
import ChartSidebarAccordion from "../ChartSidebarAccordion";
import { useSelector } from "react-redux";
import { Typography } from "@material-ui/core";
import useStyles from "../Styles";
import { aboutEntityText, donutChartAboutVisualText } from "../AboutSidebar/AboutTexts";

function CentralAZAboutTab() {
  const { central_az_tab, city_selected, irrigation_district_selected } =
    useSelector((state) => state.technical_view);
  const classes = useStyles();
  return (
    <>
      <ChartSidebarAccordion
        group_name={
          //   central_az_tab === "irrigation_district"
          //     ? `Central Arizona ${irrigation_district_selected.name} Water Deliveries`
          //     : `Central Arizona ${city_selected.name} Water Uses`
          "About the Visual"
        }
        accordion_name={'about'}
      >
        <Typography
            variant="body2"
            component="p"
            className={classes.aboutContent}
          >
            {
              donutChartAboutVisualText(central_az_tab)
            }
        </Typography>
      </ChartSidebarAccordion>
      <ChartSidebarAccordion
        group_name={
          central_az_tab === "irrigation_district"
            ? `Entity: ${irrigation_district_selected.name}`
            : `Entity: ${city_selected.name}`
        }
        accordion_name={'entity'}
      >
        <Typography
          variant="body2"
          component="p"
          className={classes.aboutContent}
        >
          {
            central_az_tab === "irrigation_district"
            ? (aboutEntityText.IRRIGATION_DIST[irrigation_district_selected.name] ? aboutEntityText.IRRIGATION_DIST[irrigation_district_selected.name] : "Information coming soon")
            : (aboutEntityText.CITY[city_selected.name] ? aboutEntityText.CITY[city_selected.name] : "Information coming soon...")
          }
        </Typography>
      </ChartSidebarAccordion>
    </>
  );
}

export default CentralAZAboutTab;
